import Image from 'next/image';
import { Input } from 'antd';
import { motion } from 'framer-motion';
import styled from 'styled-components';
export const SearchBoxLayout = styled(motion.div).withConfig({
  displayName: "SearchBoxstyle__SearchBoxLayout",
  componentId: "sc-1ueugcy-0"
})(["", " transform:translate(-50%,0%) !important;@media (max-width:", "){", " transform:unset !important;}"], {
  "position": "absolute",
  "left": "50%",
  "zIndex": "50"
}, ({
  theme
}) => theme.breakpoint.xl, {
  "left": "0px",
  "right": "0px",
  "width": "100%"
});
export const Container = styled.div.withConfig({
  displayName: "SearchBoxstyle__Container",
  componentId: "sc-1ueugcy-1"
})(["", " box-shadow:0px 20px 20px 0px #00000033;@media (max-width:", "){", "}@media (max-width:", "){", " box-shadow:0px 0px 0px 0px rgba(0,0,0,0.05),0px 1px 3px 0px rgba(0,0,0,0.05),0px 5px 5px 0px rgba(0,0,0,0.04),0px 11px 7px 0px rgba(0,0,0,0.03),0px 20px 8px 0px rgba(0,0,0,0.01),0px 31px 9px 0px rgba(0,0,0,0.00);}"], {
  "position": "relative",
  "width": "1140px",
  "borderRadius": "40px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity, 1))",
  "paddingLeft": "120px",
  "paddingRight": "120px",
  "paddingTop": "2.5rem",
  "paddingBottom": "2.5rem"
}, ({
  theme
}) => theme.breakpoint.xl, {
  "width": "100%",
  "borderRadius": "0px"
}, ({
  theme
}) => theme.breakpoint.lg, {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity, 1))",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingBottom": "2.5rem",
  "paddingTop": "4rem"
});
export const CloseIcon = styled(Image).withConfig({
  displayName: "SearchBoxstyle__CloseIcon",
  componentId: "sc-1ueugcy-2"
})(["", " @media (max-width:", "){", "}"], {
  "position": "absolute",
  "right": "1.5rem",
  "top": "1.5rem",
  "height": "18px",
  "width": "18px",
  "cursor": "pointer"
}, ({
  theme
}) => theme.breakpoint.lg, {
  "right": "1rem",
  "top": "1rem"
});
export const SearchInput = styled(Input).withConfig({
  displayName: "SearchBoxstyle__SearchInput",
  componentId: "sc-1ueugcy-3"
})(["", " .ant-input-prefix{", "}.suffixIcon{", " img{", "}}@media (max-width:", "){", "}"], {
  "alignItems": "center",
  "borderRadius": "32px",
  "paddingLeft": "0.75rem",
  "paddingRight": "0.75rem",
  "paddingTop": "0.625rem",
  "paddingBottom": "0.625rem"
}, {
  "height": "1.5rem",
  "width": "1.5rem"
}, {
  "cursor": "pointer",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(235 235 235 / var(--tw-bg-opacity, 1))",
  "padding": "0.625rem"
}, {
  "height": "0.75rem",
  "width": "0.75rem"
}, ({
  theme
}) => theme.breakpoint.lg, {
  "paddingLeft": "0.625rem",
  "paddingRight": "0.625rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem",
  "fontSize": "1.25rem",
  "lineHeight": "24px"
});
export const ResultGridWrapper = styled.div.withConfig({
  displayName: "SearchBoxstyle__ResultGridWrapper",
  componentId: "sc-1ueugcy-4"
})(["", ""], {
  "marginTop": "2rem"
});
export const GridWrapper = styled.div.withConfig({
  displayName: "SearchBoxstyle__GridWrapper",
  componentId: "sc-1ueugcy-5"
})(["", " grid-template-columns:100px calc(100% - 100px - 24px);@media (max-width:", "){", "}"], {
  "marginBottom": "1.5rem",
  "display": "grid",
  "alignItems": "baseline",
  "gap": "1.5rem"
}, ({
  theme
}) => theme.breakpoint.lg, {
  "gridTemplateColumns": "repeat(1, minmax(0, 1fr))",
  "gap": "0.5rem"
});
export const SearchTitle = styled.p.withConfig({
  displayName: "SearchBoxstyle__SearchTitle",
  componentId: "sc-1ueugcy-6"
})(["", " @media (max-width:", "){", "}"], {
  "textAlign": "right",
  "fontSize": "21px",
  "fontWeight": "700",
  "lineHeight": "24px",
  "--tw-text-opacity": "1",
  "color": "rgb(43 43 43 / var(--tw-text-opacity, 1))"
}, ({
  theme
}) => theme.breakpoint.lg, {
  "textAlign": "left"
});
export const TagWrapper = styled.div.withConfig({
  displayName: "SearchBoxstyle__TagWrapper",
  componentId: "sc-1ueugcy-7"
})(["", " max-height:", ";a{", " line-height:initial;}"], {
  "display": "flex",
  "flexWrap": "wrap",
  "gap": "0.5rem",
  "overflow": "hidden",
  "paddingBottom": "0.25rem"
}, ({
  $maxLineTag
}) => `${$maxLineTag ? `${$maxLineTag * 42}px` : 'auto'}`, {
  "minHeight": "38px"
});
export const SearchTag = styled.div.withConfig({
  displayName: "SearchBoxstyle__SearchTag",
  componentId: "sc-1ueugcy-8"
})(["", " border:", ";"], {
  "borderRadius": "0.375rem",
  "paddingLeft": "0.75rem",
  "paddingRight": "0.75rem",
  "paddingTop": "0.375rem",
  "paddingBottom": "0.375rem",
  "fontSize": "21px",
  "lineHeight": "24px",
  "--tw-text-opacity": "1",
  "color": "rgb(88 88 88 / var(--tw-text-opacity, 1))"
}, ({
  theme
}) => `1px solid ${theme.colors.grey[10]}`);